import React, {useCallback, useContext} from 'react';
import {BaseStyle} from "../../../../../styles/shared/BaseStyle";
import {useFormContext} from "react-hook-form";
import {IntervistaContext} from "../IntervistaOld";
import {AppContext} from "../../../../../App";
import {setOpenSnackbar} from "../../../../../services/AppServices";
import {setIntervista} from "../../../../../services/IntervistaServices";
import Grid from "@mui/material/Grid";
import {AccordionActions, AccordionDetails, Button, Tooltip} from "@mui/material";
import {immunodepressioni, patologie, sintomi} from "../../../../../utils/arrays/Generics";
import {bigNoteRegisterNotRequired} from "../../../../../utils/RegisterUtils";
import {getListaOf} from "../../../../../services/utils/IntervistaApiData";
import CustomMultiText from "../../../../widgets/inputs/CustomMultiText";
import {SintomiGrid} from "../content/SintomiGrid";

const SintomiStep = ({setStep}) => {
	const classes = BaseStyle();
	const {errors, getValues, trigger, register, setValue} = useFormContext();
	const intervistaContext = useContext(IntervistaContext);
	const appContext = useContext(AppContext);
	
	const goForward = useCallback(async () => {
		let result;
		let result1 = true;
		let result2 = true;
		let result3;
		let data = getValues();
		result3 = await trigger([
			("ricoverato"),
			("presentaSintomi"),
			("immunodepresso"),
			("patologieCroniche"),
		]);
		if (data["ricoverato"] === "true") {
			result1 = await trigger([
				("strutturaRicovero")
			]);
		}
		if (data["presentaSintomi"] === "true") {
			result2 = await trigger([
				("dataComparsaSintomi")
			]);
		}
		result = result1 & result2 & result3
		if (result) {
			console.log(errors)
			if (getValues()?.["presentaSintomi"] === "true" && getListaOf(sintomi, getValues()).length === 0) {
				setOpenSnackbar("warning", "Inserisci almeno un sintomo tra quelli indicati!", appContext.dispatch);
			} else if (getValues()?.["immunodepresso"] === "true" && getListaOf(immunodepressioni, getValues()).length === 0) {
				setOpenSnackbar("warning", "Inserisci almeno una tra le seguenti immunodepressioni!", appContext.dispatch);
			} else if (getValues()?.["patologieCroniche"] === "true" && getListaOf(patologie, getValues()).length === 0) {
				setOpenSnackbar("warning", "Inserisci almeno una tra le seguenti patologie!", appContext.dispatch);
			} else {
				setIntervista(getValues(), intervistaContext.dispatch);
				setStep(prevState => ++prevState);
			}
		} else {
			setOpenSnackbar("error", "Controlla bene i dati inseriti!", appContext.dispatch);
		}
	}, [intervistaContext.dispatch, appContext.dispatch, setStep, trigger, getValues, errors])
	
	return (
		<React.Fragment>
			<AccordionDetails>
				<Grid container spacing={3}>
					
					<SintomiGrid/>
					
					<Grid item xs={12}>
						<CustomMultiText
							inputRef={register(bigNoteRegisterNotRequired)}
							name={"note3"}
							label={"Note aggiuntive"}
							autoFocus={false}
							error={errors["note3"]}
						/>
					</Grid>
				</Grid>
			</AccordionDetails>
			<AccordionActions>
				<Tooltip title={"Torna al passo precedente"}>
					<Button size={"small"} variant={"text"}
					        style={{borderRadius: 24}}
					        className={classes.roundButton} onClick={() => setStep(3)}>
						<b>Torna indietro</b>
					</Button>
				</Tooltip>
				<Tooltip title={"Precompila i campi con risposte negative nel caso in cui non siano pertinenti"}>
					<Button size={"small"} color={"secondary"} variant={"contained"}
					        disableElevation
					        style={{borderRadius: 24}}
					        className={classes.roundButton}
					        onClick={() => {
						        setValue("ricoverato", "false")
						        setValue("presentaSintomi", "false")
						        setValue("immunodepresso", "false")
						        setValue("patologieCroniche", "false")
					        }}>
						<b>Non pertinente</b>
					</Button>
				</Tooltip>
				<Tooltip title={"Prosegui con il passo successivo"}>
					<Button size={"small"} color={"primary"} variant={"contained"}
					        disableElevation
					        style={{borderRadius: 24}}
					        className={classes.roundButton}
					        onClick={goForward}>
						<b>Prosegui</b>
					</Button>
				</Tooltip>
			</AccordionActions>
		</React.Fragment>
	);
};

export default React.memo(SintomiStep);
